import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Cookies } from '../../../index.js';
import { useNavigate, Link, useParams } from 'react-router-dom';
import AdSense from 'react-adsense';
import { Helmet } from "react-helmet";
import { alert_success, alert_error } from "../../../AppContext";
const MyComponent = () => {
    const [info, setInfo] = useState(null);
    const [tenkiemtien, setTenkiemtien] = useState(''); // Add the initial value as required
    const [isLoadingbutton, setIsLoadingbutton] = useState(false);
    const [countdown, setCountdown] = useState(0);
    const [ahbsdjaksjd, setAhbsdjaksjd] = useState(false);
    const [username_ig, setUsername_ig] = useState('');
    const [posts, setPosts] = useState('');
    const [currentPostId, setCurrentPostId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [nutorder, setNutorder] = useState('');
    const [sadasdsaasd, setSadasdsaasd] = useState('');
    const [savefollowing, setSaveFollowing] = useState('');
    const [id_cmt, set_id_cmt] = useState('');
    const [cauhinh, setCauhinh] = useState(''); // Set default value or fetch from props/context
    const [start, setStart] = useState(true); // Set default value or fetch from props/context
    const { slug_1, slug_2 } = useParams();
    const social = slug_1;
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    useEffect(() => {
        if (slug_2) {
            setTenkiemtien(slug_2);
            localStorage.setItem("tenkiemtien", slug_2);
        }
    }, []);
    useEffect(() => {
        check_button();
        if (start && tenkiemtien) {
            reloadPosts();
        }
    }, [tenkiemtien]);

    const check_button = () => {
        if (tenkiemtien == 'subcheo' || tenkiemtien == 'subcheo_video' || tenkiemtien == 'subcheovip') {
            setSadasdsaasd('Theo dõi');
        } else if (tenkiemtien == 'timcheo' || tenkiemtien == 'kiemtien') {
            setSadasdsaasd('Thả Tim');
        } else if (tenkiemtien == "cmtcheo" || tenkiemtien == "tiktok_comment") {
            setSadasdsaasd("Bình luận");
        } else if (tenkiemtien == "danhgiapage") {
            setSadasdsaasd("Reviews Page");
        } else if (tenkiemtien == "thamgianhomcheo") {
            setSadasdsaasd("Tham gia nhóm");
        }
    };
    const homeok = () => {
        if (social == 'tiktok') {
            switch_router('/reactapp/sunflower/tiktok/home');
        } else if (social == 'youtube') {
            switch_router('/reactapp/sunflower/youtube/home');
        } else if (social == 'facebook') {
            switch_router('/reactapp/sunflower/facebook/home');
        } else {
            switch_router('/reactapp/insta/home');
        }
    };
    const doidiem = () => {
        if (social == 'tiktok') {
            switch_router('/reactapp/exchangepoints?webappmode=showadview');
        } else {
            switch_router('/reactapp/exchangepoints/insta?webappmode=showadview');
        }
    };
    const asdasdkas = (info) => {
        if (info.status == 3) {
            alert_error(info.message);
            if (social == 'insta') {
                switch_router('/reactapp/' + social + '/home');
            }
            else {
                switch_router('/reactapp/sunflower/' + social + '/home');
            }
        } else if (info.status == 8) {
            alert_error(info.message);
            switch_router('/reactapp/sunflower/tiktok/listcauhinh');
        } else if (info.status == 7) {
            alert_error(info.message);
            switch_router('/cheofb');
        } else if (info.status == 1) {
            if (info.message.error) {
                alert_error(info.message.error);
            }
            else {
                alert_success('Lấy danh sách jop thành công');
                setPosts(info.message);
                if (info.cauhinh) {
                    setCauhinh(info.cauhinh);
                }
            }
        } else if (info.status == 0) {
            alert_error(info.message);
        }
    };
    const handlePostFocus = (idpost) => {
        const tenkiemtien = localStorage.getItem("tenkiemtien");
        const validCategories = ['thamgianhomcheo', 'timcheo', 'kiemtien', 'cmtcheo', 'camxucvipcheo', 'camxuccheo', 'tiktok_comment', 'danhgiapage', 'subcheo', 'subcheovip'];
        if (validCategories.indexOf(tenkiemtien) !== -1 && !((tenkiemtien == 'subcheo' || tenkiemtien == 'subcheovip') && (social == 'tiktok' || social == 'insta' || social == 'threads'))) {
            console.log(`Post ${idpost} focused`);
            const myCookieValue = Cookies.get('apikey');
            axios
                .post('https://hust.media/insta/nhantien.php', {
                    key: myCookieValue,
                    idpost: idpost,
                    theloai: tenkiemtien,
                    social: social
                    // binhluan: binhluan // Uncomment if needed
                })
                .then((response) => {
                    console.log(response.data);
                    dathang(response, idpost);
                })
                .catch((error) => console.log(error));
        }
        else {
            setIsLoading(false);
            // setNutorder(sadasdsaasd);
            setTimeout(() => {
                set_posts_change(idpost);
                setNutorder(sadasdsaasd);
            }, 500);
        }
    };
    const dathang = (response, idpost) => {
        setAhbsdjaksjd(false);
        // setInfo1(response.data);
        if (response.data.error || response.data.error2) {
            if (response.data.error.includes("nhiệm vụ rồi nhận điểm")) {
                alert_error(response.data.error);
                setNutorder('lỗi');
            } else if (response.data.error) {
                alert_error(response.data.error);
                setNutorder('lỗi');
                setSaveFollowing(null);
            } else if (response.data.error2) {
                alert_error(response.data.error2);
                setNutorder('lỗi');
                setSaveFollowing(null);
            }
        } else {
            if (response.data.mess.includes("điểm") || response.data.mess.includes("bạn đã được cộng")) {
                alert_success(response.data.mess);
                setNutorder('thành công');
                setSaveFollowing(null);
            } else if (response.data.mess) {
                alert_error(response.data.mess);
                setNutorder('lỗi');
                setSaveFollowing(null);
            }
        }
        // if (social !== 'tiktok') {
        //     resetIframe();
        // }
        setIsLoading(false);
        setTimeout(() => {
            set_posts_change(idpost);
        }, 500);
    };
    const filteredPosts = () => {
        if (currentPostId) {
            setPosts(posts.filter((post) => post.idpost != currentPostId));
        }
    };


    const reloadPosts = () => {
        setCountdown(5);
        setIsLoadingbutton(true);
        const intervalId = setInterval(() => {
            setCountdown(prevCountdown => {
                if (prevCountdown <= 1) {
                    clearInterval(intervalId); // Dừng đếm ngược khi countdown bằng 0
                    setIsLoadingbutton(false);
                    return 0;
                }
                return prevCountdown - 1; // Giảm giá trị countdown mỗi giây
            });
        }, 1000);
        // Cleanup interval on component unmount
        const myCookieValue = Cookies.get('apikey');
        axios
            .post('https://hust.media/insta/profile.php', {
                key: myCookieValue,
                chedo: 'getjop',
                theloai: tenkiemtien,
                social: social
            })
            .then(response => {
                const responseData = response.data;
                setInfo(responseData);
                console.log(responseData);
                asdasdkas(responseData);

                if (!start) {
                    // setAdsenseKey(prevKey => prevKey + 1);
                } else {
                    setStart(false);
                }
                if (social !== 'tiktok') {
                    // resetIframe();
                }
            })
            .catch(error => console.log(error));
        return () => clearInterval(intervalId);
    };
    const nhandiem = () => {
        setAhbsdjaksjd(true);
        const myCookieValue = Cookies.get('apikey');
        axios.post('https://hust.media/insta/nhantien.php', {
            key: myCookieValue,
            idpost: savefollowing,
            theloai: tenkiemtien,
            social: social
            // binhluan: binhluan // Nếu bạn có giá trị này, hãy thêm nó vào
        })
            .then(response => {
                console.log(response.data);
                dathang(response); // Giả sử dathang là một hàm mà bạn cần định nghĩa
            })
            .catch(error => {
                console.log(error);
            });
    };
    const handleLinkClick = (idpost) => {
        setIsLoading(true);
        setCurrentPostId(idpost);

        if (tenkiemtien == 'tiktok_comment') {
            setSaveFollowing(id_cmt);
        } else if (!savefollowing) {
            setSaveFollowing(idpost);
        } else {
            setSaveFollowing(savefollowing + ',' + idpost);
        }
        console.log(savefollowing);
        localStorage.setItem("postId", idpost);
    };
    const handleVisibilityChange = () => {
        const tenkiemtien = localStorage.getItem("tenkiemtien");
        if (document.visibilityState == "visible") {
            setNutorder('Please wait a moment 😊');

            const postId = localStorage.getItem("postId");
            if (postId) {
                if (tenkiemtien == 'tiktok_comment') {
                    handlePostFocus(id_cmt);
                } else {
                    handlePostFocus(postId);
                }
                setTimeout(() => {
                    localStorage.removeItem("postId");
                }, 500);
            }
        }
    };
    const [posts_change, set_posts_change] = useState('');
    useEffect(() => {
        filteredPosts();
    }, [posts_change]);
    useEffect(() => {
        window.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            window.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);
    const saochep = (value) => {
        alert_success('Đã sao chép');
        window.saochepnative(value);
    };
    return (
        <div>
            <div data-type="_mgwidget" data-widget-id="1662830">
            </div>
            <Helmet>
                <script>
                    {`(function(w,q){w[q] = w[q] || [];w[q].push(["_mgc.load"])})(window,"_mgq");`}
                </script>
            </Helmet>
            <AdSense.Google
                client="ca-pub-4574266110812955"
                slot="1627514116"
                style={{ display: 'block', height: 100 }}
                format=""
            />
            <div className="container mt-0">
                <div className="max-h-16">
                    <div className="cards">
                        <div id="hientruyen"></div>
                    </div>
                </div>
                <div className="row">
                    <div className="text-center">
                        <div className="mt-1" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <div className="px-2">Page: {tenkiemtien}</div>
                            <button style={{ textDecoration: 'none' }} to={`${social == 'tiktok' ? '/reactapp/sunflower/home' : '/reactapp/insta/home'}`}
                                type="button"
                                className={`rounded-xl px-2 py-1 bg-green-400 text-white hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-blue-300 text-sm 
                                    ${isLoadingbutton ? 'disabledok' : ''}`}
                                disabled={isLoadingbutton}
                                onClick={homeok}
                            >
                                {isLoadingbutton ? (
                                    <div>Home {countdown}</div>
                                ) : (
                                    <div>Home</div>
                                )}
                            </button>
                        </div>
                        <div className="mb-1">
                            <div className="py-1 space-x-2">
                                <button
                                    type="button"
                                    className="px-1 text-base font-medium  py-0.5 bg-transparent border border-white text-white rounded hover:bg-white hover:text-blue-500 focus:outline-none focus:ring-2 focus:ring-white"
                                    onClick={doidiem}
                                >
                                    Đổi điểm sang Coins
                                </button>
                                <button
                                    type="button"
                                    className={`text-base font-medium px-2  py-0.5 bg-transparent border border-white text-white rounded hover:bg-white hover:text-blue-500 focus:outline-none focus:ring-2 focus:ring-white
                                 ${isLoadingbutton ? 'disabledok' : ''}`}
                                    disabled={isLoadingbutton}
                                    onClick={reloadPosts}
                                >
                                    {isLoadingbutton ? (
                                        <div>Tải lại danh sách {countdown}</div>
                                    ) : (
                                        <div>Tải lại danh sách</div>
                                    )}
                                </button>
                            </div>
                            {((social == 'tiktok' || social == 'insta' || social == 'threads') && (tenkiemtien == 'subcheo' || tenkiemtien == 'subcheo_video' || tenkiemtien == 'subcheovip')) && (
                                <button
                                    onClick={nhandiem}
                                    disabled={ahbsdjaksjd}
                                    type="button"
                                    className="px-10 py-2 rounded-md text-sm font-medium text-white bg-red-400 hover:bg-purple-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                >
                                    {ahbsdjaksjd ? (
                                        <div className="spinner-border" role="status"></div>
                                    ) : (
                                        <div className="font-medium">Nhận tất cả điểm</div>
                                    )}
                                </button>
                            )}
                            {username_ig && social !== 'tiktok' && (
                                <div className="text-xs mb-0">Nick cấu hình {username_ig}</div>
                            )}
                        </div>
                    </div>
                    {!posts ? (
                        <div className="container-fluid">
                            <div className="row" style={{ backgroundColor: '#FFB6C1' }}>
                                <p className="text-center" style={{ color: '#fff' }}>
                                    <div className="text-center spinner-border" role="status"></div>
                                    <br />
                                    Đang tải danh sách
                                </p>
                            </div>
                        </div>
                    ) : (
                        posts.map((post, index) => (
                            <div key={index} className={'col-6 col-md-4 col-lg-3 mb-3'}>
                                {(tenkiemtien == 'tiktok_comment' && social == 'tiktok') ||
                                    (tenkiemtien !== 'danhgiapage' && tenkiemtien !== 'cmtcheo' && tenkiemtien !== 'tiktok_comment' && (social == 'facebook' || social == 'tiktok' || (social !== 'tiktok'))) ? (
                                    <div
                                        className="py-1 card d-flex align-items-center justify-content-center"
                                        style={{
                                            backgroundImage: `url(https://picsum.photos/300/200?random=${post.idpost})`,
                                            backgroundSize: 'cover',
                                        }}
                                    >
                                        <h5 className="card-title">{social == 'tiktok' && tenkiemtien !== 'kiemtien' ? post.link : post.idpost}</h5>
                                        <a
                                            style={{ textDecoration: 'none' }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleLinkClick(post.idpost);
                                            }}
                                            href={post.lienket}
                                            target="_blank"
                                            className="px-10 py-2 rounded-md text-sm font-medium text-white bg-pink-400 hover:bg-purple-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
                                            rel="noopener noreferrer"
                                        >
                                            {isLoading && currentPostId == post.idpost ? (
                                                <div className="spinner-border" role="status"></div>
                                            ) : (
                                                <div>
                                                    {(tenkiemtien != 'camxuccheo' && tenkiemtien != 'camxucvipcheo') ? (<>
                                                        {currentPostId == post.idpost ? <span>{nutorder}</span> : <span>{sadasdsaasd}</span>}
                                                    </>) : (<span>{post.loaicx}</span>)}

                                                </div>
                                            )}
                                        </a>
                                        {/* <div className="overflow-y-auto max-h-64 border border-gray-300 rounded">
                                            {Object.entries(post.nd).map(([key, value]) => (
                                                <div key={key} onClick={() => saochep(value)} className="p-4 py-2 px-2 border bg-white border-gray-300 rounded">
                                                    {value.comment}
                                                </div>
                                            ))}
                                        </div> */}
                                    </div>
                                ) :
                                    ((tenkiemtien == 'danhgiapage' || tenkiemtien == 'cmtcheo') && (social == 'youtube' || social == 'tiktok' || social == 'facebook') ?
                                        (<>
                                            <div
                                                className="py-1 card d-flex align-items-center justify-content-center"
                                                style={{
                                                    backgroundImage: `url(https://picsum.photos/300/200?random=${post.idpost})`,
                                                    backgroundSize: 'cover',
                                                }}
                                            >
                                                <h5 className="card-title">{post.idpost}</h5>
                                                <a
                                                    onClick={(e) => { e.stopPropagation(); handleLinkClick(post.idpost); }}
                                                    href={post.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="px-10 py-2 rounded-md text-sm font-medium text-white bg-red-400 hover:bg-purple-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                                >
                                                    {isLoading && currentPostId === post.idpost ? (
                                                        <div className="spinner-border" role="status"></div>
                                                    ) : (
                                                        <>
                                                            {currentPostId === post.idpost ? <span>{nutorder}</span> : <span>{sadasdsaasd}</span>}
                                                        </>
                                                    )}
                                                </a>
                                                <div className="overflow-y-auto max-h-64 border border-gray-300 rounded">
                                                    {post.nd.map((value, key) => (
                                                        <div
                                                            key={key}
                                                            onClick={() => saochep(value)}
                                                            className="p-4 py-2 px-2 border bg-white border-gray-300 rounded"
                                                        >
                                                            {value}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </>) : null
                                    )
                                }
                            </div>
                        ))

                    )}
                </div>
            </div>
        </div>
    );
};

export default MyComponent;
